// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"733":"5aca81cb","870":"5aca81cb"}[chunkId] + ".chunk.css";
};